var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("body", [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.LoadingPage,
              expression: "LoadingPage"
            }
          ],
          staticClass: "preview"
        },
        [
          _c("h1", { staticClass: "read-only" }, [
            _vm._v("Dream & Dream 시즌 2 로그인")
          ]),
          _vm._v(" "),
          _c("header", [
            _c("div", [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "56",
                    height: "19.413",
                    viewBox: "0 0 56 19.413"
                  }
                },
                [
                  _c("g", { attrs: { "data-name": "Text/Amway" } }, [
                    _c("path", {
                      staticStyle: { fill: "#ed174c" },
                      attrs: {
                        "data-name": "Red Mark",
                        d:
                          "M5.16 88.044s31.054-7.655 54.062-2.261l.072-.25s-20.077-5.948-53.748 1.3z",
                        transform: "translate(-4.04 -69.004)"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#00305e" },
                      attrs: {
                        "data-name": "m = Amway",
                        d:
                          "M75.678 26.863v1.267a2.309 2.309 0 0 1 .652-.921 2.591 2.591 0 0 1 1.657-.552 2.8 2.8 0 0 1 .921.162 2.21 2.21 0 0 1 1.353 1.449 2.829 2.829 0 0 1 2.578-1.593 2.721 2.721 0 0 1 1.924.737c.816.8.847 1.666.847 3.841v5h-2.394v-4.44c0-1.5-.031-1.812-.276-2.21a1.053 1.053 0 0 0-.994-.527 1.248 1.248 0 0 0-1.027.543 4.518 4.518 0 0 0-.261 1.994v4.638h-2.395V31.52a3.665 3.665 0 0 0-.243-1.886 1.145 1.145 0 0 0-.98-.552 1.261 1.261 0 0 0-.621.164c-.7.4-.716 1.086-.716 2.861v4.141H73.31v-9.39z",
                        transform: "translate(-59.697 -22.739)"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#00305e" },
                      attrs: {
                        "data-name": "w = Amway",
                        d:
                          "M148.59 27.78h2.445l-2.445 9.385h-2.235l-1.42-6.342-1.4 6.342h-2.267l-2.448-9.385h2.447l1.287 5.87 1.322-5.87H146l1.306 5.87z",
                        transform: "translate(-113.198 -23.657)"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#00305e" },
                      attrs: {
                        "data-name": "a = Amway",
                        d:
                          "M207.7 31.319a3.488 3.488 0 0 1-.621 2.283 1.4 1.4 0 0 1-1.044.527 1.492 1.492 0 0 1-1.337-1.1 4.263 4.263 0 0 1-.26-1.611 3.612 3.612 0 0 1 .5-2.066 1.528 1.528 0 0 1 1.191-.691 1.289 1.289 0 0 1 .961.471 3.164 3.164 0 0 1 .61 2.187zm.123 4.8h2.348v-9.4h-2.3v1.213a2.256 2.256 0 0 0-2.086-1.431c-1.6 0-3.683 1.377-3.683 5.073 0 2.935 1.5 4.747 3.5 4.747a2.427 2.427 0 0 0 2.21-1.232z",
                        transform: "translate(-164.863 -22.612)"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#00305e" },
                      attrs: {
                        "data-name": "Y = Amway",
                        d:
                          "M251.418 27.78h2.436l-2.683 9.312a6.653 6.653 0 0 1-.98 2.248c-.44.47-.961.687-2.9.687-.278 0-.39-.017-.635-.035v-2.085h.635a1.629 1.629 0 0 0 1.011-.236 1.339 1.339 0 0 0 .355-.941 3.053 3.053 0 0 0-.184-.8l-2.6-8.154h2.6l1.534 6.323z",
                        transform: "translate(-200.613 -23.686)"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { fill: "#00305e" },
                      attrs: {
                        "data-name": "A = Amway",
                        d:
                          "m19.41 11.924 1.289 4.94h-2.512zM17.887 9.11 13.86 21.931h2.957l.751-2.714h3.775l.77 2.723h2.976L20.894 9.11z",
                        transform: "translate(-11.138 -8.363)"
                      }
                    })
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("section", { staticClass: "content" }, [
            _c("div", [
              _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("a", { on: { click: _vm.goLoginTry } }, [
                  _vm._v("로그인 하러 가기")
                ])
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("span", [_vm._v("Dream & Dream ")]),
      _vm._v("시즌 "),
      _c("span", [_vm._v("2")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("\n                    증정품 교환을 위해"),
      _c("br"),
      _vm._v(
        "\n                    한국암웨이 회원 확인이 필요합니다.\n                    "
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13e1b8d0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13e1b8d0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/couponsys/couponcheck.vue
// module id = null
// module chunks = 